/* ACHILLES - product card image slider
   Swipe/drag through a product's images directly on the card (collection, home, search, page, product).
   No libraries. Loads its own stylesheet, so the theme only needs one script tag.

   Cards are .grid-product[data-product-handle] (Impulse). Images are fetched on demand
   from /products/<handle>.js, so the initial page payload is unchanged.

   Styling follows Mango: swipe on touch, arrows on desktop hover, NO dots.
   Set SHOW_DOTS = true to bring the position dots back.

   NOTE: after editing achilles-card-slider.css, bump CSS_VERSION below so browsers and
   the Shopify CDN pick the new stylesheet up (the asset's own ?v= belongs to this JS file,
   not to the CSS, so it will not change when only the CSS is edited). */
(function () {
  'use strict';

  var CSS_VERSION = '7';
  var SHOW_DOTS = false;

  var CARD = '.grid-product[data-product-handle]';
  var MASK = '.grid-product__image-mask';
  var RATIO = '.grid__image-ratio';
  var MAX_SLIDES = 6;
  var DRAG_THRESHOLD = 8;
  var COMMIT_RATIO = 0.15;
  var PREFETCH_CONCURRENCY = 3;
  var DOTS_HOLD = 1400;
  var DOTS_PEEK = 1100;

  var me = document.currentScript && document.currentScript.src;
  if (me && !document.querySelector('link[href*="achilles-card-slider.css"]')) {
    var href = me.split('?')[0].replace('achilles-card-slider.js', 'achilles-card-slider.css');
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href + '?v=' + CSS_VERSION;
    document.head.appendChild(l);
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache = Object.create(null);
  var queue = [];
  var active = 0;

  function widthUrl(url, w) {
    return url.split('?')[0] + '?width=' + w + '&format=webp';
  }

  function fetchImages(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.images || !p.images.length) return [];
        return p.images.slice(0, MAX_SLIDES);
      })
      .catch(function () { return []; });
    return cache[handle];
  }

  function pump() {
    while (active < PREFETCH_CONCURRENCY && queue.length) {
      var job = queue.shift();
      active++;
      job().then(function () { active--; pump(); }, function () { active--; pump(); });
    }
  }

  function build(card, images) {
    if (card.dataset.acsReady) return;
    var mask = card.querySelector(MASK);
    var ratio = mask && mask.querySelector(RATIO);
    var first = ratio && ratio.querySelector('image-element, img');
    if (!ratio || !first || images.length < 2) return;
    card.dataset.acsReady = '1';

    var origImg = ratio.querySelector('img');
    var fit = origImg ? getComputedStyle(origImg).objectFit : 'cover';
    if (origImg) origImg.draggable = false;

    var track = document.createElement('div');
    track.className = 'acs-track';

    var slide0 = document.createElement('div');
    slide0.className = 'acs-slide';
    slide0.appendChild(first);
    track.appendChild(slide0);

    for (var i = 1; i < images.length; i++) {
      var s = document.createElement('div');
      s.className = 'acs-slide';
      var img = document.createElement('img');
      // deliberately NOT the theme's "image-element" class: that class is opacity:0 until the
      // theme's own <image-element> fade-in runs, which never happens for slides we create.
      img.className = 'acs-img';
      // NOT loading="lazy" either: these slides sit outside the clipped track, so the browser
      // treats them as far off-screen and never loads them (blank white slides).
      img.decoding = 'async';
      img.draggable = false;
      img.alt = (origImg && origImg.alt) || '';
      img.src = widthUrl(images[i], 720);
      img.srcset = widthUrl(images[i], 360) + ' 360w, ' + widthUrl(images[i], 540) + ' 540w, ' +
                   widthUrl(images[i], 720) + ' 720w, ' + widthUrl(images[i], 1080) + ' 1080w';
      img.sizes = (origImg && origImg.sizes) || '(min-width: 769px) 25vw, 50vw';
      img.style.objectFit = fit;
      s.appendChild(img);
      track.appendChild(s);
    }
    ratio.appendChild(track);
    ratio.classList.add('acs-on');

    var dots = null, dotTimer = null;
    if (SHOW_DOTS) {
      dots = document.createElement('div');
      dots.className = 'acs-dots';
      for (var d = 0; d < images.length; d++) {
        var dot = document.createElement('span');
        dot.className = 'acs-dot' + (d === 0 ? ' is-active' : '');
        dots.appendChild(dot);
      }
      mask.appendChild(dots);
    }
    function showDots(ms) {
      if (!dots) return;
      dots.classList.add('is-visible');
      if (dotTimer) clearTimeout(dotTimer);
      dotTimer = setTimeout(function () { dots.classList.remove('is-visible'); }, ms || DOTS_HOLD);
    }

    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'acs-arrow acs-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image'); prev.innerHTML = '&#8249;';
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'acs-arrow acs-arrow--next';
    next.setAttribute('aria-label', 'Next image'); next.innerHTML = '&#8250;';
    mask.appendChild(prev); mask.appendChild(next);

    var index = 0, dragging = false, decided = false, startX = 0, startY = 0, dx = 0;
    var startT = 0, width = 0, suppressClick = false;

    function setX(px, animate) {
      track.style.transition = (animate && !reduceMotion) ? 'transform .32s cubic-bezier(.22,.61,.36,1)' : 'none';
      track.style.transform = 'translate3d(' + px + 'px,0,0)';
    }
    function go(i, animate) {
      index = Math.max(0, Math.min(images.length - 1, i));
      width = ratio.clientWidth || 1;
      setX(-index * width, animate !== false);
      if (dots) {
        var all = dots.children;
        for (var k = 0; k < all.length; k++) all[k].classList.toggle('is-active', k === index);
      }
      prev.classList.toggle('is-hidden', index === 0);
      next.classList.toggle('is-hidden', index === images.length - 1);
    }
    go(0, false);
    showDots(DOTS_PEEK);

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(index - 1); showDots(); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(index + 1); showDots(); });

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; decided = false; dx = 0;
      startX = e.clientX; startY = e.clientY; startT = Date.now();
      width = ratio.clientWidth || 1;
      if (e.pointerType === 'mouse') e.preventDefault();
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var mx = e.clientX - startX, my = e.clientY - startY;
      if (!decided) {
        if (Math.abs(mx) < DRAG_THRESHOLD && Math.abs(my) < DRAG_THRESHOLD) return;
        if (Math.abs(my) > Math.abs(mx)) { dragging = false; return; }
        decided = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        ratio.classList.add('acs-dragging');
        showDots(6000);
      }
      dx = mx;
      var atEdge = (index === 0 && dx > 0) || (index === images.length - 1 && dx < 0);
      if (atEdge) dx *= 0.35;
      setX(-index * width + dx, false);
      if (e.cancelable) e.preventDefault();
    });

    function end() {
      if (!dragging) return;
      var wasDrag = decided;
      dragging = false; decided = false;
      ratio.classList.remove('acs-dragging');
      if (!wasDrag) return;
      var speed = Math.abs(dx) / Math.max(1, Date.now() - startT);
      var moved = Math.abs(dx) > width * COMMIT_RATIO || speed > 0.5;
      go(moved ? index + (dx < 0 ? 1 : -1) : index);
      showDots();
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 250);
      dx = 0;
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('lostpointercapture', end);

    var link = card.querySelector('a.grid-product__link') || card;
    link.draggable = false;
    link.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var swallow = function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    };
    link.addEventListener('click', swallow, true);
    card.addEventListener('click', swallow, true);

    window.addEventListener('resize', function () { go(index, false); });
  }

  function load(card) {
    if (card.dataset.acsInit) return;
    card.dataset.acsInit = '1';
    var handle = card.dataset.productHandle;
    if (!handle) return;
    queue.push(function () {
      return fetchImages(handle).then(function (imgs) { build(card, imgs); });
    });
    pump();
  }

  function hookEager(card) {
    var eager = function () { load(card); };
    card.addEventListener('pointerenter', eager, { once: true });
    card.addEventListener('pointerdown', eager, { once: true });
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { io.unobserve(en.target); load(en.target); }
    });
  }, { rootMargin: '300px 0px' }) : null;

  function scan(root) {
    (root || document).querySelectorAll(CARD).forEach(function (card) {
      if (card.dataset.acsSeen) return;
      card.dataset.acsSeen = '1';
      hookEager(card);
      if (io) io.observe(card); else load(card);
    });
  }

  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1) scan(n.matches && n.matches(CARD) ? n.parentNode : n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();